<app-account-page-wrapper title="Welcome back" subtitle="Sign in to access your deceased consumer verification dashboard.">
  <form novalidate (submit)="onSubmit($event)">
    <div class="form-group">
      <label for="email">Email</label>
      <input id="email" type="text" class="form-control" placeholder="you@company.com" [formField]="loginForm.email" />
      @if (loginForm.email().touched() && loginForm.email().invalid()) {
        <span class="field-error">{{ loginForm.email().errors()[0].message }}</span>
      }
    </div>

    <div class="form-group">
      <label for="password">Password</label>
      <app-password-input
        id="password"
        placeholder="Your password"
        [formField]="loginForm.password"
      />
      @if (loginForm.password().touched() && loginForm.password().invalid()) {
        <span class="field-error">{{ loginForm.password().errors()[0].message }}</span>
      }
    </div>

    <button type="submit" class="btn btn-primary btn-block" [disabled]="loginForm().submitting()">
      @if (loginForm().submitting()) {
        <span class="btn-spinner" aria-hidden="true"></span>
        Signing in...
      } @else {
        Sign in
      }
    </button>
  </form>

  <p class="form-note">Don't have an account? <a [routerLink]="[routes.accountRegister.url]">Create one</a></p>
</app-account-page-wrapper>
